import { useEffect, useRef, useState } from "react";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import InputMask from "react-input-mask";
import "./personsRegister.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getPessoasCadastros,
  getUpdate,
  getPessoaById,
} from "../../services/api_cadastros_pessoas";
import Swal from "sweetalert2";

const PersonRegister = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;

  const [nome, setNome] = useState("");
  const [cpf, setCpf] = useState("");
  const [nascimento, setDataNascimento] = useState("");
  const [email, setEmail] = useState("");
  const [celular, setCelular] = useState("");
  const [fixo, setFixo] = useState("");
  const [tipo, setTipo] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)

  const inputRefs = {
    Nome: useRef(null),
    Email: useRef(null),
    Tipo: useRef(null),
    Nascimento: useRef(null)
  };

  useEffect(() => {
    const fetchPessoa = async () => {
      try {
        const response = await getPessoaById(id);
        const pessoa = response.data.pessoa;
        setNome(pessoa.nome || "");
        setCpf(pessoa.cpf || "");
        setDataNascimento(pessoa.nascimento || "");
        setEmail(pessoa.email || "");
        setCelular(pessoa.celular || "");
        setFixo(pessoa.fixo || "");
        setTipo(pessoa.tipo || "");
        setLoading(false);
      } catch (error) {
        console.error("Erro ao obter dados da pessoa:", error);
      }
    };

    if (id) {
      fetchPessoa();
    }
  }, [id]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (!nome || !cpf || !tipo) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento dos campos Nome, CPF e Tipo é obrigatório.",
      });
      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getPessoasCadastros(body);
      if (response && response.status === 200) {
        regret();
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar os dados:", error);
        handleOpenModal(
          "Erro ao atualizar os dados",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUpdate = async (body) => {
    try {
      delete body.cpf
      const response = await getUpdate(id, body);
      if (response && response.status === 200) {
        regret();
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar os dados:", error);
        handleOpenModal(
          "Erro ao atualizar os dados",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        nome,
        cpf,
        celular,
        fixo,
        email,
        nascimento,
        tipo,
      };

      if (id) {
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleNome = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setNome(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O campo Nome não pode ultrapassar 50 caracteres"
      );
    }
  };

  const handleEmail = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setEmail(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O campo E-mail não pode ultrapassar 50 caracteres"
      );
    }
  };

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === 'Enter' && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus = nextFieldRef.current.inputRef || nextFieldRef.current;
  
      if (typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      } else {
        console.warn('O elemento de input não tem o método focus.');
      }
    }
  };
  

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Cadastros / Cadastro de pessoas" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {id && isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form className="mt-4">
            <Row>
              <Col md={9} className="mb-3">
                <Form.Group controlId="formName">
                  <Form.Label>Nome:</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Nome"
                    value={nome}
                    onChange={handleNome}
                    ref={inputRefs.Nome}
                    onKeyDown={(e)=>handleKeyDown(e, inputRefs.Nascimento)}
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="mb-3">
                <Form.Group controlId="formCpf">
                  <Form.Label>CPF:</Form.Label>
                  <Form.Control
                    type="text"
                    as={InputMask}
                    mask="999.999.999-99"
                    placeholder="CPF"
                    value={cpf}
                    disabled={!!id}
                    onChange={(e) => setCpf(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={3} className="mb-3">
                <Form.Group controlId="formNascimento">
                  <Form.Label>Data de Nascimento:</Form.Label>
                  <Form.Control
                    type="date"
                    value={nascimento}
                    onChange={(e) => setDataNascimento(e.target.value)}
                    ref={inputRefs.Nascimento}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Email)}
                  />
                </Form.Group>
              </Col>
              <Col md={9} className="mb-3">
                <Form.Group controlId="formEmail">
                  <Form.Label>E-mail:</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="E-mail"
                    value={email}
                    onChange={handleEmail}
                    ref={inputRefs.Email}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Tipo)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formCelular">
                  <Form.Label>Celular:</Form.Label>
                  <Form.Control
                    type="text"
                    as={InputMask}
                    mask="(99)99999-9999"
                    placeholder="Celular"
                    value={celular}
                    onChange={(e) => setCelular(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formFixo">
                  <Form.Label>Fixo:</Form.Label>
                  <Form.Control
                    type="text"
                    as={InputMask}
                    mask="(99)9999-9999"
                    placeholder="Telefone fixo"
                    value={fixo}
                    onChange={(e) => setFixo(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formTipo">
                  <Form.Label>Tipo:</Form.Label>
                  <Form.Control
                    as="select"
                    value={tipo}
                    ref={inputRefs.Tipo}
                    onChange={(e) => setTipo(e.target.value)}
                  >
                    <option value="">Selecione um tipo</option>
                    <option value="1">Cliente</option>
                    <option value="2">Cliente-Admin</option>
                    <option value="3">Manutentor</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};
export default PersonRegister;
